import type { CSSProperties } from "react";

/**
 * Serial `#` column width from digit count of the last row number
 * (1–9 → 1ch, 10–99 → 2ch, …) plus room for the trailing "." and padding.
 */
export const getSeriesNumberColumnStyle = (
  itemCount: number,
  overrides: CSSProperties = {}
): CSSProperties => {
  const digits = String(Math.max(itemCount, 1)).length;

  return {
    width: `calc(${digits}ch + 1ch + 8px)`,
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "top",
    ...overrides,
  };
};

/** Formats a 1-based serial for `#` columns, e.g. 1 → "1." */
export const formatSeriesNumber = (n: number) => `${n}.`;
